import { createContext } from 'react';
import { LegoControllerRxjs } from './controller';
import { ILegoContext } from './models';

export const LegoV2Context = createContext<ILegoContext>({
  controller: new LegoControllerRxjs(),
  onSubmit: () => {},
  validationMode: 'onChange',
  validate: () => {},
});
